import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {RechercheCataloguePage} from './RechercheCataloguePage'


const RechercheCatalogueWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Catalogues', path: '/catalogues', isSeparator: false, isActive: true },
              ]}>Recherche</PageTitle>
              <RechercheCataloguePage />
            </>
          }
        />
      
        <Route index element={<Navigate to='/recherche-catalogue/liste' />} />
      </Routes>
    </>
  )
}

export {RechercheCatalogueWrapper}
